/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var Fill = __ol.style.Fill;
var props = {
  color: [String, Array]
};

var methods = {
  /**
   * @return {ol.style.Fill}
   * @protected
   */
  createStyle: function createStyle() {
    return new Fill({
      color: this.color
    });
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.setFill(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.setFill(undefined);
  }
};

var watch = {
  color: function color(value) {
    if (!this.$style) return;

    this.$style.setColor(value);
    this.refresh();
  }
};

var Style = {
  name: 'vl-style-fill',
  mixins: [core.style],
  props: props,
  methods: methods,
  watch: watch
};

var index = {
  Style: Style,
  install: function install(Vue) {
    Vue.component(Style.name, Style);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/fill-style/index.js
// module id = 1180
// module chunks = 1